/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { InlineMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import api from "../../utils/api";
import {
  FiUpload,
  FiFileText,
  FiDownload,
  FiCheck,
  FiBook,
  FiFile,
  FiList,
  FiType,
  FiChevronRight,
  FiHome,
  FiArrowLeft,
  FiAlertCircle,
  FiLoader,
  FiSave,
  FiTrash2
} from 'react-icons/fi';
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  Card,
  CardContent,
  Typography,
  Checkbox,
  Stack,
  IconButton,
  Chip,
  Button,
  Box,
  TextField
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";


export default function PdfToLatex() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("readable");
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  const [selectedModule, setSelectedModule] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");

  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState("");
  const [questionType, setQuestionType] = useState([]);

  // Add Chapter modal states
  const [showAddChapter, setShowAddChapter] = useState(false);
  const [newChapterName, setNewChapterName] = useState("");
  const [chapterLoading, setChapterLoading] = useState(false);

  // Add Topic modal states
  const [showAddTopic, setShowAddTopic] = useState(false);
  const [newTopicName, setNewTopicName] = useState("");
  const [topicLoading, setTopicLoading] = useState(false);



  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("");


  const [uploadedQuestionKeys, setUploadedQuestionKeys] = useState([]);

  const [examTypes, setExamTypes] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState([]);

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const [editingQuestion, setEditingQuestion] = useState(null);
  const [editingOption, setEditingOption] = useState(null);

  const [tempStem, setTempStem] = useState("");
  const [tempOption, setTempOption] = useState("");

  const handleTagKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const value = tagInput.trim();
      if (!value) return;

      if (!tags.includes(value)) {
        setTags([...tags, value]);
      }

      setTagInput("");
    }
  };

  const removeTag = (index) => {
    const updated = tags.filter((_, i) => i !== index);
    setTags(updated);
  };

  useEffect(() => {
    setUploadedQuestionKeys(getUploadedQuestions());
  }, []);

  const getQuestionKey = (q) => {
    return `${q.stem}__${q.answer}`;
  };

  const UPLOADED_KEY = "uploaded_pdf_questions";

  const getUploadedQuestions = () => {
    try {
      return JSON.parse(localStorage.getItem(UPLOADED_KEY)) || [];
    } catch {
      return [];
    }
  };

  const saveUploadedQuestions = (keys) => {
    localStorage.setItem(UPLOADED_KEY, JSON.stringify(keys));
  };

  useEffect(() => {
    fetchModules();
    fetchLevel()
    fetchQuestionType()
    fetchExamType()
  }, []);

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("module/moduleCurl", fd);
      if (Array.isArray(modulesResponse.data.getResponse)) {
        setModules(modulesResponse.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchCourses(moduleId) {
    if (!moduleId) return setCourses([]);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getCourseOnchange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("id", moduleId);

      const courseResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(courseResponse.data)) {
        setCourses(courseResponse.data);
      } else {
        setCourses([]);
      }
    } catch (error) {
      setCourses([]);
    }
  }

  async function fetchSubjects(moduleId) {
    if (!moduleId) {
      setSubjects([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");

      const programType = "getSubjectByModule";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("role", role);
      fd.append("module", moduleId);

      const subjectResponse = await api.post("subject/subjectCurl", fd);
      if (Array.isArray(subjectResponse.data.data)) {
        setSubjects(subjectResponse.data.data);
      } else {
        setSubjects([]);
      }
    } catch (error) {
      setSubjects([]);
    }
  }

  async function fetchChapters(subjectId) {
    if (!subjectId) {
      setChapters([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getChapterOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("subjectId", subjectId);

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(chapterResponse.data.data)) {
        setChapters(chapterResponse.data.data);
      } else {
        setChapters([]);
      }
    } catch (error) {
      setChapters([]);
    }
  }

  async function fetchTopics(subjectId, chapterId) {
    if (!subjectId || !chapterId) {
      setTopics([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("subjectId", subjectId);
      fd.append("chapterId", chapterId);

      const topicResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(topicResponse.data.data)) {
        setTopics(topicResponse.data.data);
      } else {
        setTopics([]);
      }
    } catch (error) {
      setTopics([]);
    }
  }

  async function handleAddTopic() {
    if (!selectedSubject || !selectedChapter) {
      alert("Please select Subject and Chapter first");
      return;
    }

    if (!newTopicName.trim()) {
      alert("Please enter topic name");
      return;
    }

    setTopicLoading(true);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("programType", "addTopic");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("subject", selectedSubject);
      fd.append("chapter", selectedChapter);
      fd.append("topic", newTopicName.trim());

      const res = await api.post("topic/topicCurl", fd);

      if (res.data?.status === true) {
        alert("Topic added successfully");

        // 🔁 Refresh topics
        await fetchTopics(selectedSubject, selectedChapter);

        // 🧠 Auto-select new topic
        const added = res.data?.insertedId;
        if (added) {
          setSelectedTopic(String(added));
        }

        setShowAddTopic(false);
        setNewTopicName("");
      } else {
        alert(res.data?.data || "Failed to add topic");
      }
    } catch (e) {
      alert("Error adding topic");
    } finally {
      setTopicLoading(false);
    }
  }

  async function fetchExamType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getExamTypes");

      const response = await api.post("question/examType", fd);

      if (response.data?.status) {
        const options = response.data.examTypes.map((exam) => ({
          value: exam.id,
          label: exam.examType,
        }));

        setExamTypes(options);
      }
    } catch (error) {
      console.error("Error fetching exam types:", error);
    }
  }


  useEffect(() => {
    if (selectedModule) {
      fetchCourses(selectedModule);
    }
  }, [selectedModule]);

  useEffect(() => {
    if (selectedSubject) {
      fetchChapters(selectedSubject);
    } else {
      setSelectedChapter("");
      setSelectedTopic("");
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (selectedSubject && selectedChapter) {
      fetchTopics(selectedSubject, selectedChapter);
    } else {
      setSelectedTopic("");
    }
  }, [selectedSubject, selectedChapter]);

  const deleteQuestion = (qNumber) => {
    setResult((prev) => {
      const updatedQuestions = prev.questions.filter(q => q.number !== qNumber);
      return { ...prev, questions: updatedQuestions };
    });

    // also remove from selectedQuestions
    setSelectedQuestions(prev => prev.filter(q => q.number !== qNumber));
  };

  const convert = async () => {
    if (!file) {
      setError("Please upload a PDF file");
      return;
    }

    setLoading(true);
    setError("");
    setResult(null);
    setSelectedQuestions([]);

    const form = new FormData();
    form.append("pdf", file);

    try {
      const res = await fetch("https://pdf-scanner-5awo.onrender.com/api/convert", {
        method: "POST",
        body: form
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.error);

      setResult(json);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const toggleQuestion = (question) => {
    const key = getQuestionKey(question);
    if (uploadedQuestionKeys.includes(key)) return;

    setSelectedQuestions((prev) => {
      const exists = prev.find((q) => q.number === question.number);
      if (exists) {
        return prev.filter((q) => q.number !== question.number);
      }
      return [...prev, question];
    });
  };

  async function fetchLevel() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getLevelDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("level/levelCurl", fd);
      if (Array.isArray(response.data.getLevelDetails)) {
        setLevels(response.data.getLevelDetails);
      } else {
        setLevels([]);
      }
    } catch (error) {
      setLevels([]);
    }
  }

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);
      if (Array.isArray(response.data.getQuestionTypeDetails)) {
        setQuestionType(response.data.getQuestionTypeDetails);
      } else {
        setQuestionType([]);
      }
    } catch (error) {
      setQuestionType([]);
    }
  }

  const renderLatexInline = (text) => {
    const regex = /\\\((.*?)\\\)|\\\[(.*?)\\\]|\$(.*?)\$/g;

    const parts = [];
    let last = 0;
    let match;
    let i = 0;

    while ((match = regex.exec(text)) !== null) {
      if (match.index > last) {
        parts.push(<span key={last}>{text.slice(last, match.index)}</span>);
      }

      const math = match[1] || match[2] || match[3];
      parts.push(<InlineMath key={i++} math={math} />);
      last = regex.lastIndex;
    }

    if (last < text.length) {
      parts.push(<span key={last}>{text.slice(last)}</span>);
    }

    return parts;
  };

  const renderMixedMath = (text) => {
    if (!text) return null;

    const s = he.decode(text);
    const imgRegex = /!\[[^\]]*?\]\((.*?)\)/g;

    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = imgRegex.exec(s)) !== null) {
      // 1. Push text before the image
      if (match.index > lastIndex) {
        parts.push(
          <span key={key++}>
            {renderLatexInline(s.slice(lastIndex, match.index))}
          </span>
        );
      }

      // 2. Push the image inside a container that allows inline-flex behavior
      parts.push(
        <div
          key={key++}
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            margin: "5px"
          }}
        >
          <img
            src={match[1]}
            alt="diagram"
            style={{
              height: "auto",
              maxHeight: "150px", // Limits height so they don't break the row
              maxWidth: "200px",  // Limits width
              borderRadius: "4px",
              border: "1px solid #eee"
            }}
          />
        </div>
      );

      lastIndex = imgRegex.lastIndex;
    }

    if (lastIndex < s.length) {
      parts.push(
        <span key={key++}>
          {renderLatexInline(s.slice(lastIndex))}
        </span>
      );
    }

    // 3. Wrap everything in a container that allows the images to flow horizontally
    return (
      <div style={{ display: "block", lineHeight: "1.6" }}>
        {parts}
      </div>
    );
  };

  const [editingAnswer, setEditingAnswer] = useState(null);
  const updateAnswer = (qNumber, newAnswer) => {
    setResult(prev => {
      const updated = prev.questions.map(q =>
        q.number === qNumber ? { ...q, answer: newAnswer } : q
      );
      return { ...prev, questions: updated };
    });

    setEditingAnswer(null);
  };
  const updateQuestionStem = (qNumber) => {
    setResult(prev => {
      const updated = prev.questions.map(q =>
        q.number === qNumber ? { ...q, stem: tempStem } : q
      );
      return { ...prev, questions: updated };
    });

    setEditingQuestion(null);
  };

  const updateOption = (qNumber, label) => {
    setResult(prev => {
      const updated = prev.questions.map(q => {
        if (q.number !== qNumber) return q;

        return {
          ...q,
          options: q.options.map(opt =>
            opt.label === label ? { ...opt, text: tempOption } : opt
          )
        };
      });

      return { ...prev, questions: updated };
    });

    setEditingOption(null);
  };

  const renderReadable = () => (
    <div className="questions-preview">
      <div className="preview-header">
        <h4><FiFileText /> Readable Version (Exam Style)</h4>
        <span className="questions-count">{result.questions.length} questions</span>
      </div>

      <div className="questions-list">
        {result.questions.map((q) => {
          const checked = selectedQuestions.some((sq) => sq.number === q.number);
          const key = getQuestionKey(q);
          const isUploaded = uploadedQuestionKeys.includes(key);

          return (
            <Card
              key={q.number}
              sx={{
                borderRadius: 3,
                border: checked ? "2px solid #1976d2" : "1px solid #e5e7eb",
                background: isUploaded ? "#f9fafb" : "#fff",
                opacity: isUploaded ? 0.7 : 1,
                transition: "0.2s",
                "&:hover": {
                  boxShadow: 3
                }
              }}
            >
              <CardContent>
                {/* HEADER */}
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Checkbox
                    checked={checked || isUploaded}
                    disabled={isUploaded}
                    onChange={() => toggleQuestion(q)}
                  />

                  <Chip label={`Q${q.number}`} color="primary" size="small" />

                  {isUploaded && (
                    <Chip label="Uploaded" color="success" size="small" />
                  )}

                  <Box sx={{ flexGrow: 1 }} />

                  <Stack direction="row" spacing={1} alignItems="center">
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<EditIcon />}
                      onClick={() => {
                        setEditingQuestion(q.number);
                        setTempStem(q.stem);
                      }}
                      sx={{
                        textTransform: "none",
                        borderRadius: 2
                      }}
                    >
                      Edit Question
                    </Button>

                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<AutoFixHighIcon />}
                      onClick={() => {
                        setEditingOption(q.number);
                      }}
                      sx={{
                        textTransform: "none",
                        borderRadius: 2
                      }}
                    >
                      Edit Options
                    </Button>

                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => deleteQuestion(q.number)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Stack>
                </Stack>

                {/* QUESTION */}
                <Box mt={2}>
                  {editingQuestion === q.number ? (
                    <Stack spacing={1}>
                      <TextField
                        multiline
                        rows={3}
                        value={tempStem}
                        onChange={(e) => setTempStem(e.target.value)}
                        fullWidth
                      />

                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => updateQuestionStem(q.number)}
                      >
                        Save
                      </Button>
                    </Stack>
                  ) : (
                    <Typography variant="body1">
                      {renderMixedMath(q.stem)}
                    </Typography>
                  )}
                </Box>

                {/* OPTIONS */}
                <Box mt={2}>
                  {editingOption === q.number ? (
                    <Stack spacing={1}>
                      {q.options.map((opt) => (
                        <TextField
                          key={opt.label}
                          label={`Option ${opt.label}`}
                          value={opt.text}
                          onChange={(e) => {
                            const updated = result.questions.map((ques) => {
                              if (ques.number !== q.number) return ques;

                              return {
                                ...ques,
                                options: ques.options.map((o) =>
                                  o.label === opt.label
                                    ? { ...o, text: e.target.value }
                                    : o
                                )
                              };
                            });

                            setResult({ ...result, questions: updated });
                          }}
                          fullWidth
                        />
                      ))}

                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => setEditingOption(null)}
                      >
                        Save Options
                      </Button>
                    </Stack>
                  ) : (
                    <Stack spacing={1}>
                      {q.options.map((opt) => (
                        <Box
                          key={opt.label}
                          sx={{
                            border: "1px solid #e5e7eb",
                            borderRadius: 2,
                            px: 1.5,
                            py: 1,
                            backgroundColor: "#fafafa",
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                            transition: "0.2s",
                            "&:hover": {
                              borderColor: "#cbd5e1",
                              backgroundColor: "#f8fafc"
                            }
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: "#4f46e5", minWidth: 24 }}
                          >
                            ({opt.label})
                          </Typography>

                          <Typography variant="body2" sx={{ flex: 1 }}>
                            {renderMixedMath(opt.text)}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  )}
                </Box>

                {/* ANSWER */}
                <Box mt={2}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body2" fontWeight={600}>
                      Answer:
                    </Typography>

                    {editingAnswer === q.number ? (
                      <>
                        <select
                          value={q.answer || ""}
                          onChange={(e) => updateAnswer(q.number, e.target.value)}
                        >
                          <option value="">Select</option>
                          {q.options.map((opt) => (
                            <option key={opt.label} value={opt.label}>
                              {opt.label}
                            </option>
                          ))}
                        </select>

                        <Button
                          size="small"
                          onClick={() => setEditingAnswer(null)}
                        >
                          Save
                        </Button>
                      </>
                    ) : (
                      <>
                        <Chip
                          label={q.answer || "Not Set"}
                          color={q.answer ? "success" : "default"}
                          size="small"
                        />

                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<EditIcon />}
                          onClick={() => setEditingAnswer(q.number)}
                        >
                          Correct option
                        </Button>
                      </>
                    )}
                  </Stack>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );

  async function addBulk() {
    if (selectedQuestions.length === 0) {
      alert("Please select at least one question");
      return;
    }

    if (!selectedModule || !selectedSubject || !selectedChapter || !selectedTopic || !selectedQuestionType) {
      alert("Please fill all required fields");
      return;
    }

    try {
      const payload = {
        questions: selectedQuestions.map((q, index) => ({
          number: index + 1,
          stem: q.stem,
          options: q.options.map((o) => ({
            label: o.label,
            text: o.text,
          })),
          answer: q.answer,
        })),
      };

      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "addBulkQuestions";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("module", selectedModule);
      fd.append("course", selectedCourse);
      fd.append("subject", selectedSubject);
      fd.append("chapter", selectedChapter);
      fd.append("topic", selectedTopic);

      if (selectedLevel) {
        fd.append("level", selectedLevel);
      }

      fd.append("questionType", selectedQuestionType);
      tags.forEach((tag) => {
        fd.append("tags[]", tag);
      });
      if (selectedExamType.length > 0) {
        selectedExamType.forEach((exam) => {
          fd.append("examType[]", exam.value);
        });
      }
      fd.append("questions", JSON.stringify(payload));

      const response = await api.post("question/questionCurl", fd);
      console.log("res", response)
      const resData = response?.data;

      if (resData?.status === true) {

        const importCost = 200;

        const currentWallet = Number(localStorage.getItem("walletBalance")) || 0;

        // ❌ Prevent if low balance
        if (currentWallet < importCost) {
          alert("❌ Insufficient balance. Minimum ₹200 required to import.");
          return;
        }

        // ✅ Deduct amount
        const updatedWallet = currentWallet - importCost;
        localStorage.setItem("walletBalance", updatedWallet);

        // 🔥 Optional: update UI instantly
        window.dispatchEvent(new Event("walletUpdated"));


        const { inserted, skipped, total } = resData.details || {};

        alert(
          `✅ ${resData.data}\n\n` +
          `Total: ${total}\n` +
          `Inserted: ${inserted}\n` +
          `Skipped: ${skipped}`
        );

        const newUploadedKeys = selectedQuestions.map(getQuestionKey);
        const updatedKeys = Array.from(
          new Set([...uploadedQuestionKeys, ...newUploadedKeys])
        );

        saveUploadedQuestions(updatedKeys);
        setUploadedQuestionKeys(updatedKeys);
        setSelectedQuestions([]);

      } else {
        alert(response.data.data || "Error");
      }
    } catch (error) {
      console.error("Error uploading questions:", error);
      alert("Error uploading questions. Please try again.");
    }
  }

  const downloadDocx = async () => {
    if (!result) return;

    try {
      const res = await fetch(
        "https://pdf-scanner-5awo.onrender.com/api/download-docx",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ questions: result.questions }),
        }
      );

      if (!res.ok) throw new Error("Failed to download DOCX");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "questions.docx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Failed to download DOCX");
    }
  };

  async function handleAddChapter() {
    if (!selectedSubject) {
      alert("Please select Subject first");
      return;
    }

    if (!newChapterName.trim()) {
      alert("Please enter chapter name");
      return;
    }

    setChapterLoading(true);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("programType", "addChapter");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("subject", selectedSubject);
      fd.append("chapter", newChapterName.trim());

      const res = await api.post("chapter/chapterCurl", fd);

      if (res.data?.status === true) {
        alert("Chapter added successfully");

        // 🔁 Refresh chapters
        await fetchChapters(selectedSubject);

        // 🧠 Auto-select newly added chapter
        const added = res.data?.insertedId;
        if (added) {
          setSelectedChapter(String(added));
        }

        setShowAddChapter(false);
        setNewChapterName("");
      } else {
        alert(res.data?.data || "Failed to add chapter");
      }
    } catch (e) {
      alert("Error adding chapter");
    } finally {
      setChapterLoading(false);
    }
  }


  const resetForm = () => {
    setFile(null);
    setResult(null);
    setError("");
    setSelectedQuestions([]);
    setSelectedModule("");
    setSelectedCourse("");
    setSelectedSubject("");
    setSelectedChapter("");
    setSelectedTopic("");
    setSelectedQuestionType("");
    setSelectedLevel("");
    setSelectedExamType("");
  };

  return (
    <div className="pdf-to-latex-container">


      {/* Upload Card */}
      <div className="form-card">
        <div className="card-header">
          <h3><FiUpload /> Upload PDF</h3>
          <p className="card-subtitle">
            Upload a PDF file containing questions to convert them to LaTeX format
          </p>
        </div>

        <div className="card-content">
          <div className="upload-section">
            <div className="upload-instructions">
              <p><strong>Supported format:</strong> .pdf</p>
              <p><strong>Note:</strong> Ensure the PDF contains clear, readable text questions</p>
            </div>

            <div className="file-upload-container">
              <input
                type="file"
                accept="application/pdf"
                className="form-control"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                  setError("");
                }}
              />
            </div>

            {error && (
              <div className="error-message">
                <FiAlertCircle /> {error}
              </div>
            )}

            <div className="upload-actions">
              <button
                className="btn btn-danger"
                onClick={resetForm}
                disabled={loading}
              >
                Reset
              </button>

              <button
                className="btn primary"
                onClick={convert}
                disabled={loading || !file}
              >
                {loading ? (
                  <>
                    <FiLoader className="spinner" />
                    Converting...
                  </>
                ) : (
                  <>
                    <FiUpload /> Convert PDF
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Category Selection Card */}
      {file && (
        <div className="form-card">
          <div className="card-header">
            <h3><FiBook /> Chapter Details</h3>
            <p className="card-subtitle">Select the category for your imported questions</p>
          </div>

          <div className="card-content">
            <div className="form-grid">
              {/* Class */}
              <div className="form-group">
                <label className="form-label">
                  <FiBook /> Class <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  value={selectedModule}
                  onChange={(e) => {
                    const moduleId = e.target.value;
                    setSelectedModule(moduleId);
                    setSelectedSubject("");
                    setSelectedChapter("");
                    setSelectedTopic("");
                    fetchCourses(moduleId);
                    fetchSubjects(moduleId);
                  }}
                >
                  <option value="">Select a Class</option>
                  {modules.map((module) => (
                    <option key={module.id} value={module.id}>
                      {module.moduleName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Subject */}
              <div className="form-group">
                <label className="form-label">
                  <FiFileText /> Subject <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  value={selectedSubject}
                  onChange={(e) => {
                    const subjectId = e.target.value;
                    setSelectedSubject(subjectId);
                    fetchChapters(subjectId);
                  }}
                >
                  <option value="">Select a Subject</option>
                  {subjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subjectName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Chapter */}
              <div className="form-group">
                <label className="form-label">
                  <FiList /> Chapter <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  value={selectedChapter}
                  onChange={(e) => {
                    if (e.target.value === "__add__") {
                      setShowAddChapter(true);
                      return;
                    }
                    const chapterId = e.target.value;
                    setSelectedChapter(chapterId);
                    fetchTopics(selectedSubject, chapterId);
                  }}
                >
                  <option value="">Select a Chapter</option>

                  {/* ✅ SHOW ONLY AFTER SUBJECT IS SELECTED */}
                  {selectedSubject && (
                    <option value="__add__">➕ Add Chapter</option>
                  )}

                  {chapters.map((chapter) => (
                    <option key={chapter.id} value={chapter.id}>
                      {chapter.chapterName}
                    </option>
                  ))}
                </select>


              </div>

              {/* Topic */}
              <div className="form-group">
                <label className="form-label">
                  <FiList /> Topic <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  value={selectedTopic}
                  onChange={(e) => {
                    if (e.target.value === "__add__") {
                      setShowAddTopic(true);
                      return;
                    }
                    setSelectedTopic(e.target.value);
                  }}
                >
                  <option value="">Select a Topic</option>

                  {/* ✅ SHOW ONLY AFTER CHAPTER IS SELECTED */}
                  {selectedChapter && (
                    <option value="__add__">➕ Add Topic</option>
                  )}

                  {topics.map((topic) => (
                    <option key={topic.id} value={topic.id}>
                      {topic.topicName}
                    </option>
                  ))}
                </select>

              </div>

              {/* Question Type */}
              <div className="form-group">
                <label className="form-label">
                  <FiType /> Question Type <span className="required">*</span>
                </label>
                <select
                  className="form-select"
                  value={selectedQuestionType}
                  onChange={(e) => setSelectedQuestionType(e.target.value)}
                >
                  <option value="">Select Question Type</option>
                  {questionType.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.questionType}
                    </option>
                  ))}
                </select>
              </div>

              {/* Level */}
              <div className="form-group">
                <label className="form-label">
                  Select Level
                </label>
                <select
                  className="form-select"
                  value={selectedLevel}
                  onChange={(e) => setSelectedLevel(e.target.value)}
                >
                  <option value="">Select a Level</option>
                  {levels.map((level) => (
                    <option key={level.id} value={level.id}>
                      {level.levelName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Exam Type */}
              {/* Exam Type */}
              <div className="form-group">
                <label className="form-label">
                  Exam Type
                </label>

                <Select
                  options={examTypes}
                  isMulti
                  value={selectedExamType}
                  onChange={(selected) => setSelectedExamType(selected)}
                  placeholder="Select Exam Types"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>

              {/* Tags */}
              <div className="form-group">
                <label className="form-label">
                  <FiList /> Tags
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Type tag and press Enter"
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={handleTagKeyDown}
                />

                <div className="tag-container">
                  {tags.map((tag, index) => (
                    <span key={index} className="tag-item">
                      {tag}
                      <button
                        type="button"
                        className="tag-remove"
                        onClick={() => removeTag(index)}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Results Section */}
      {result && (
        <div className="form-card">
          <div className="card-header">
            <h3><FiFileText /> Converted Results</h3>
            <p className="card-subtitle">
              Preview and import your converted questions
              <button
                className="download-sample"
                onClick={downloadDocx}
              >
                <FiDownload /> Download DOCX
              </button>
            </p>
          </div>

          <div className="card-content">
            {/* Tabs */}
            <div className="results-tabs">
              {["readable", "formatted", "document", "raw"].map((tab) => (
                <button
                  key={tab}
                  className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "readable" ? "Readable Version" :
                    tab === "formatted" ? "Formatted LaTeX" :
                      tab === "document" ? "LaTeX Document" : "Raw JSON"}
                </button>
              ))}
            </div>

            {/* Import Button */}
            <div className="import-actions">
              <button
                className="btn import-btn"
                onClick={addBulk}
                disabled={selectedQuestions.length === 0}
              >
                <FiSave /> Import Questions ({selectedQuestions.length})
              </button>
            </div>

            {/* Tab Content */}
            <div className="tab-content">
              {activeTab === "readable" && renderReadable()}

              {activeTab === "formatted" && (
                <div className="code-block">
                  <pre>{result.latex_questions}</pre>
                </div>
              )}

              {activeTab === "document" && (
                <div className="code-block dark">
                  <pre>{result.latex_document}</pre>
                </div>
              )}

              {activeTab === "raw" && (
                <div className="code-block">
                  <pre>{JSON.stringify(result, null, 2)}</pre>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .pdf-to-latex-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }

        .katex {
  display: inline-block;
  font-size: 1em;
}

.katex-display {
  display: block;
  margin: 10px 0;
}

.delete-btn {
  margin-left: auto;
  background: #fee2e2;
  border: none;
  color: #dc2626;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.delete-btn:hover {
  background: #fecaca;
}
  .answer-box {
  margin-top: 10px;
  padding: 8px 12px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #065f46;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
}

          /* Header */
          .header-card {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            margin-bottom: 1.5rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
          }

          .question-text {
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 1rem;
  display: flow-root; /* Ensures the container wraps around floated/inline images */
}

/* Add this to handle the image group specifically */
.question-text img {
  display: inline-block !important; /* Overrides your previous block display */
  margin: 5px !important;
}

          .header-content h1 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1f2937;
            margin: 0 0 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .header-content p {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0 0 1rem;
          }

          /* Breadcrumb */
          .breadcrumb {
            padding-top: 1rem;
            border-top: 1px solid #f3f4f6;
          }

          .breadcrumb-list {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .question-text span,
.option-text span {
  white-space: normal;
}

          .tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.tag-item {
  background: #eef2ff;
  color: #4338ca;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tag-remove {
  border: none;
  background: transparent;
  color: #4338ca;
  cursor: pointer;
  font-size: 14px;
}

.tag-remove:hover {
  color: #ef4444;
}

          .breadcrumb-list li {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .breadcrumb-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #6b7280;
            text-decoration: none;
            font-size: 0.875rem;
            transition: color 0.2s;
          }

          .edit-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}

.edit-block input,
.edit-block textarea {
  font-size: 0.85rem;
}

.option-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-btn {
  font-size: 12px;
  padding: 3px 6px;
}

          .breadcrumb-item:hover {
            color: #3b82f6;
          }

          .breadcrumb-item.active {
            color: #1f2937;
            font-weight: 500;
          }

          .breadcrumb-separator {
            color: #9ca3af;
            width: 16px;
            height: 16px;
          }

          /* Form Cards */
          .form-card {
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            overflow: hidden;
            margin-bottom: 1.5rem;
          }

          .card-header {
            padding: 1.25rem 1.5rem;
            border-bottom: 1px solid #f3f4f6;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          }

          .card-header h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0 0 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .card-subtitle {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .download-sample {
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
            color: #3b82f6;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.2s;
            background: none;
            border: none;
            cursor: pointer;
            font-size: 0.875rem;
          }

          .download-sample:hover {
            color: #2563eb;
            text-decoration: underline;
          }

          .card-content {
            padding: 1.5rem;
          }

          /* Form Grid */
          .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 1.5rem;
          }

          .form-group {
            margin-bottom: 0;
          }

          .form-label {
            display: block;
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .required {
            color: #ef4444;
            font-weight: 600;
          }

          /* Form Controls */
          .form-select,
          .form-control {
            width: 100%;
            padding: 0.625rem 0.875rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            color: #374151;
            background: white;
            transition: all 0.2s;
          }

          .form-select:focus,
          .form-control:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          /* Upload Section */
          .upload-section {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }

          .upload-instructions {
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 0.5rem;
            padding: 1rem;
          }

          .upload-instructions p {
            margin: 0.5rem 0;
            font-size: 0.875rem;
            color: #4b5563;
          }

          .file-upload-container {
            border: 2px dashed #d1d5db;
            border-radius: 0.5rem;
            padding: 1.5rem;
            background: #f9fafb;
            transition: all 0.3s;
          }

          .file-upload-container:hover {
            border-color: #3b82f6;
            background: #f0f9ff;
          }

          .error-message {
            background: #fef2f2;
            border: 1px solid #fecaca;
            color: #dc2626;
            padding: 0.75rem 1rem;
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
          }

          .upload-actions {
            display: flex;
            gap: 1rem;
            justify-content: flex-end;
          }

          /* Buttons */
          .btn {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 1.5rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          }

          .btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .btn.primary {
            background: #3b82f6;
            color: white;
          }

          .btn.primary:hover:not(:disabled) {
            background: #2563eb;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
          }

          .btn.secondary {
            background: #f3f4f6;
            color: #374151;
            border: 1px solid #e5e7eb;
          }

          .btn.secondary:hover:not(:disabled) {
            background: #e5e7eb;
          }

          .spinner {
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          /* Results Tabs */
          .results-tabs {
            display: flex;
            gap: 0.5rem;
            margin-bottom: 1.5rem;
            border-bottom: 1px solid #e5e7eb;
            padding-bottom: 0.5rem;
          }

          .tab-button {
            padding: 0.75rem 1.5rem;
            background: none;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: #6b7280;
            cursor: pointer;
            transition: all 0.2s;
          }

          .tab-button:hover {
            background: #f3f4f6;
            color: #374151;
          }

          .tab-button.active {
            background: #3b82f6;
            color: white;
          }

          .import-actions {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 1.5rem;
          }

          .answer-section {
  margin-top: 10px;
}

.edit-btn {
  margin-left: 10px;
  background: #e0f2fe;
  border: none;
  color: #0369a1;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.edit-btn:hover {
  background: #bae6fd;
}

.add-answer-btn {
  background: #fef3c7;
  border: none;
  color: #92400e;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.add-answer-btn:hover {
  background: #fde68a;
}

.answer-edit {
  display: flex;
  gap: 10px;
  align-items: center;
}

.save-btn {
  background: #10b981;
  color: white;
}
  .save-btn:hover {
  background: #10b981;
  color: white;
}

          .import-btn {
            background: #10b981;
            color: white;
          }

          .import-btn:hover:not(:disabled) {
            background: #059669;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
          }

          /* Tab Content */
          .tab-content {
            background: #f9fafb;
            border-radius: 0.5rem;
            overflow: hidden;
          }

          /* Questions Preview */
          .questions-preview {
            padding: 1.5rem;
          }

          .preview-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
            padding-bottom: 0.75rem;
            border-bottom: 1px solid #e5e7eb;
          }

          .preview-header h4 {
            font-size: 1rem;
            font-weight: 600;
            color: #374151;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .questions-count {
            background: #e0f2fe;
            color: #0369a1;
            padding: 0.25rem 0.75rem;
            border-radius: 999px;
            font-size: 0.75rem;
            font-weight: 500;
          }

          .questions-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .question-card {
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 0.75rem;
            padding: 1.25rem;
            transition: all 0.2s;
          }

          .question-card:hover {
            border-color: #d1d5db;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }

          .modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 420px;
  max-width: 90%;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}


          .question-card.selected {
            border-color: #3b82f6;
            border-left: 4px solid #3b82f6;
          }

          .question-card.uploaded {
            opacity: 0.7;
            background: #f9fafb;
          }

          .question-header {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            margin-bottom: 1rem;
          }

          .checkbox-container {
            position: relative;
            cursor: pointer;
          }

          .checkbox-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          .checkmark {
            position: relative;
            height: 1.25rem;
            width: 1.25rem;
            background-color: white;
            border: 2px solid #d1d5db;
            border-radius: 0.375rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .checkbox-container input:checked ~ .checkmark {
            background-color: #3b82f6;
            border-color: #3b82f6;
          }

          .checkmark:after {
            content: "✓";
            color: white;
            font-size: 0.75rem;
            font-weight: bold;
            display: none;
          }

          .checkbox-container input:checked ~ .checkmark:after {
            display: block;
          }

          .question-number {
            background: #eef2ff;
            color: #4f46e5;
            font-weight: 600;
            padding: 0.25rem 0.75rem;
            border-radius: 999px;
            font-size: 0.875rem;
          }

          .uploaded-badge {
            margin-left: auto;
            background: #dcfce7;
            color: #166534;
            padding: 0.25rem 0.75rem;
            border-radius: 0.375rem;
            font-size: 0.75rem;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 0.25rem;
          }

          .question-content {
            margin-left: 2rem;
          }

          .question-text {
            font-size: 0.9375rem;
            line-height: 1.6;
            color: #4b5563;
            margin-bottom: 1rem;
          }

          .options-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 0.5rem;
          }

       .option-item {
  display: flex;
  align-items: flex-start;
}

.option-text {
  display: inline-block;
}
          .option-label {
            font-weight: 600;
            color: #4f46e5;
            min-width: 1.25rem;
          }

          .option-text {
            font-size: 0.875rem;
            line-height: 1.5;
            color: #1f2937;
          }

          /* Code Blocks */
          .code-block {
            background: white;
            border-radius: 0.5rem;
            padding: 1.5rem;
            overflow-x: auto;
          }

          .code-block.dark {
            background: #1f2937;
          }

          .code-block pre {
            margin: 0;
            font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
            font-size: 0.875rem;
            line-height: 1.5;
            white-space: pre-wrap;
          }

          .code-block.dark pre {
            color: #e5e7eb;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .pdf-to-latex-container {
              padding: 1rem;
            }

            .form-grid {
              grid-template-columns: 1fr;
            }

            .upload-actions,
            .import-actions {
              flex-direction: column;
            }

            .btn {
              width: 100%;
              justify-content: center;
            }

            .results-tabs {
              flex-wrap: wrap;
            }

            .tab-button {
              flex: 1;
              min-width: 120px;
            }
          }

          @media (max-width: 480px) {
            .header-card {
              padding: 1rem;
            }

            .header-content h1 {
              font-size: 1.5rem;
            }

            .card-content {
              padding: 1rem;
            }

            .question-header {
              flex-wrap: wrap;
            }

            .uploaded-badge {
              margin-left: 0;
              margin-top: 0.5rem;
            }
          }
        `}
      </style>

      {/* Add Chapter Modal */}
      {showAddChapter && (
        <div className="modal-overlay">
          <div className="modal-card">
            <h3>➕ Add Chapter</h3>

            <div className="form-group">
              <label>Chapter Name *</label>
              <input
                type="text"
                className="form-control"
                value={newChapterName}
                onChange={(e) => setNewChapterName(e.target.value)}
                placeholder="Enter chapter name"
              />
            </div>

            <div className="modal-actions">
              <button
                className="btn btn-danger"
                onClick={() => {
                  setShowAddChapter(false);
                  setNewChapterName("");
                }}
              >
                Cancel
              </button>

              <button
                className="btn primary"
                disabled={chapterLoading}
                onClick={handleAddChapter}
              >
                {chapterLoading ? "Adding..." : "Add Chapter"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Topic Modal */}
      {showAddTopic && (
        <div className="modal-overlay">
          <div className="modal-card">
            <h3>➕ Add Topic</h3>

            <div className="form-group">
              <label>Topic Name *</label>
              <input
                type="text"
                className="form-control"
                value={newTopicName}
                onChange={(e) => setNewTopicName(e.target.value)}
                placeholder="Enter topic name"
              />
            </div>

            <div className="modal-actions">
              <button
                className="btn btn-danger"
                onClick={() => {
                  setShowAddTopic(false);
                  setNewTopicName("");
                }}
              >
                Cancel
              </button>

              <button
                className="btn primary"
                disabled={topicLoading}
                onClick={handleAddTopic}
              >
                {topicLoading ? "Adding..." : "Add Topic"}
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}